import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { OktaConnector } from '../../connector';

export const OktaService = IntegrationService.make({
  connector: OktaConnector,
  name: Integration_Service_Names_Enum.Okta,
});
